// extracted by mini-css-extract-plugin
module.exports = {"comp":"L_comp__OiQAU"};